// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"price-input_inputWrapper__36yKz","inputPrefix":"price-input_inputPrefix__mQ4xX"};